/** convert second to minutes and seconds */
export function convertStoMs(seconds: number) {
  let minutes = ~~(seconds / 60);
  let extraSeconds = seconds % 60;
  return Math.floor(minutes) + "min " + Math.floor(extraSeconds) + "sec";
}
